import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../logo.svg";
import config from "../../config";

export default function PageHeaderPublic() {
  return (
    <header
      className="sticky top-0 z-50"
      style={{
        backgroundImage:
          "linear-gradient(135deg, #f59d00, #e63a10 22.98%, #e40077 48.32%, #83388d 72.38%, #304392)",
      }}
    >
      <nav>
        <div className="flex shadow-md p-2 h-16 relative">
          <div className="flex justify-center flex-wrap content-center">
            <Link to="/">
              <Logo className="text-white w-10 md:w-14 mx-2" />
            </Link>
          </div>
          <div className="flex flex-wrap items-center justify-center mr-3 sm:mr-8 font-skyBold text-l md:text-4xl text-white">
            <Link to="/">PXL</Link>
          </div>
          <div className="flex flex-wrap absolute top-5 right-3 sm:right-8 font-skyMedium text-m md:text-xl text-white">
            <Link to={config.redirectLogin}>LOGIN</Link>
          </div>
        </div>
      </nav>
    </header>
  );
}
